export var ELoadState;
(function (ELoadState) {
    ELoadState["INIT"] = "INIT";
    ELoadState["IS_LOADING"] = "IS_LOADING";
    ELoadState["SUCCESS"] = "SUCCESS";
    ELoadState["FAILED"] = "FAILED";
})(ELoadState || (ELoadState = {}));
